import React from 'react';
import logomarca from '../../images/logomarca300px.png';

function Logo300(props) {
  return <img src={logomarca} alt="Logo" className={props.tamanho} />;
}

export default Logo300;